import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import { RouterLinks } from '../../constants';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';


declare var $: any;
declare var accounting: any;
declare function notify(): any;
declare function initPolicyOverviewTabs(): any;
declare function initNavPositioning(): any;

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    standalone: false
})
export class DocumentsComponent implements OnInit, AfterViewInit {


  policyId = '';
  selectedEntity = Entity.Policy;
  RouterLinks = RouterLinks;
  inProgress = environment.inProgress;
  
  constructor(
    public router: Router
  ) {
    
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      $('#app-bar-desktop').find('#more').addClass('is-active');
       $('#overview-sub-3').removeClass('d-none');
       $('#overview-sub-3 .navbar-sub__nav').html('Documents');
       $('.navbar-sub__more').addClass('d-none');
    }, 2000);
  }

  ngOnInit(): void {
    
    
  }

}
